import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import InputField from "../../../components/Controls/InputField/InputField";
import { SelectComponent } from "../../../components/Controls/Select/Select";
import * as actions from "../../../store/requests/actions";
import { injectIntl } from "react-intl";
import './style.scss';

const Filterform = ({ intl: { messages }, setSearchValues }) => {
  const dispatch = useDispatch();
  const { requestResources, rejectionReasons } = useSelector((state) => state.requests);
  const [requestResourcesOptions, setRequestResourcesOptions] = useState([]);
  const [rejectionReasonsOptions, setRejectionReasonsOptions] = useState([]);
  const payload = { page: 1, requestStatus: 7, sort: "created_at,desc" };
  const initialValues = {
    search: "",
    requestSource: 0, //ddl
    rejectionReasonId: 0, //ddl
  };

  const Filterchema = Yup.object().shape({
    search: Yup.string(),
    requestSource: Yup.object().nullable(),
    rejectionReasonId: Yup.object().nullable(),
  });

  const formik = useFormik({
    initialValues,
    validationSchema: Filterchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {},
  });

  // Get Rejection Reasons 
  useEffect(() => {
      dispatch(actions.rejectionReasonsRequest());
      return () => {
        dispatch(actions.rejectionReasonsReceive([]));
      };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  useEffect(() => {
      if (!requestResources.length) dispatch(actions.requestSourcesRequest());
      return () => {
        dispatch(actions.requestSourcesReceive([]));
      };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    //add all option
    if (requestResources)
      setRequestResourcesOptions([
        { id: 0, name: messages.requests.all },
        ...requestResources,
      ]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requestResources]);

  useEffect(() => {
    //add all option
    if (rejectionReasons)
      setRejectionReasonsOptions([
        { id: 0, title: messages.requests.all_reasons },
        ...rejectionReasons,
      ]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rejectionReasons]);

  const searchWithInput = (e, name) => {
    formik.setFieldValue(name, e.target.value);
    setSearchValues({ search: e.target.value, requestSource: formik.values.requestSource, rejectionReasonId: formik.values.rejectionReasonId });
    dispatch(
      actions?.rejectedRequestsRequest({
        ...payload,
        requestSource: formik.values.requestSource,
        search: e.target.value,
      })
    );
  };
  const searchWithSelect = (e, name) => {
    formik.setFieldValue(name, e.target.value);
    setSearchValues({ search: formik.values.search, requestSource: formik.values.requestSource, rejectionReasonId: e.target.value });
    dispatch(
      actions?.rejectedRequestsRequest({
        ...payload,
        ...formik.values,
        requestSource: e.target.value,
      })
    );
  };
  const searchWithReason = (e, name) => {
    formik.setFieldValue(name, e.target.value);
    setSearchValues({ search: formik.values.search, requestSource: formik.values.requestSource, rejectionReasonId: e.target.value });
    dispatch(
      actions?.rejectedRequestsRequest({
        ...payload,
        ...formik.values,
        rejectionReasonId: e.target.value,
      })
    );
  };
  
  return (
    <div>
      <form className="form fv-plugins-bootstrap fv-plugins-framework">
        <div className="row" style={{ flexWrap: 'nowrap'}}>
          <div className="col-md-4">
            <InputField
              size="small"
              className={'bg-white phone_number'}
              label={messages.requests.search_by_phone_or_name_or_id_placholder}
              id="search"
              name="search"
              value={formik.values.search}
              changeHandler={formik.handleChange}
              error={formik.errors.search}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  searchWithInput(e, "search");
                }
              }}
            />
          </div>
          <div className="col-md-4 selection">
            <SelectComponent
              className={'bg-white'}
              size="small"
              name="requestSource"
              list={requestResourcesOptions}
              keyName="name"
              valueKeyName="id"
              value={formik.values.requestSource}
              handleChange={(e) => searchWithSelect(e, "requestSource")}
              error={formik.errors.requestSource}
            />
          </div>
          <div className="col-md-4 selection">
            <SelectComponent
              className={'bg-white'}
              size="small"
              name="rejectionReasonId"
              list={rejectionReasonsOptions}
              keyName="title"
              valueKeyName="id"
              value={formik.values.rejectionReasonId}
              handleChange={(e) => searchWithReason(e, "rejectionReasonId")}
              error={formik.errors.rejectionReasonId}
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default injectIntl(Filterform);
